import { useMemo } from "react";
import { useParams } from "react-router-dom";
import GenericPlanner from "../../../../feature-module/academic/planning/components/GenericPlanner/GenericPlanner";
import useGenericPlanner from "../../../../feature-module/academic/planning/hooks/useGenericPlanner";
import Loader from "../../../Common/loader";
import CustomAlert from "components/Common/ui/CustomAlert";

const TeacherRoutine = () => {
  const { id } = useParams<{ id: string }>(); 
  const teacherIds = useMemo(() => (id ? [id] : []), [id]); // Memoize teacherIds
  const { data, isLoading, error } = useGenericPlanner({ role: "teacher", teacherIds });

  if (isLoading) return <Loader/>;
  if (error) return <CustomAlert type="error" message={error} />;

  return (
    <div className="p-2">
        <GenericPlanner role="teacher" data={data} />
    </div>
  );
};

export default TeacherRoutine;
